import type { IconSvgObject } from './types';

const MouseOffIcon: IconSvgObject = [
  ["path", { d: "M11.9922 7V5.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M1.99219 2L21.9922 22", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M7.96484 2.97169C9.00222 2.34925 10.3234 2 11.9931 2C17.9932 2 19.4932 6.50998 19.4932 12C19.4932 12.8223 19.4595 13.6225 19.3821 14.389", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M5.62695 5.60645C4.78443 7.34428 4.49219 9.57666 4.49219 12C4.49219 17.49 5.99212 22 11.9922 22C15.0244 22 16.9074 20.8481 18.0282 19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default MouseOffIcon;
